define('TescoMobile_DataLayer/js/datalayer-event',['jquery', 'underscore', 'TescoMobile_DataLayer/js/datalayer-mutations', 'TescoMobile_DataLayer/js/datalayer-extra-trigger-actions', 'TescoMobile_Catalog/js/model/deal', 'Magento_Customer/js/customer-data', 'TescoMobile_DataLayer/js/algolia', 'TescoMobile_Catalog/js/view/deal-device', 'forgesha256', 'domReady!'], function ($, _, DataLayerMutation, DataLayerExtraTriggers, deal, customerData) {
  'use strict';

  function init(event) {
    if (event.eventDirectTrigger) {
      _.each(event.dataActions, function (dataAction, key) {
        event.eventData = processEventDataAction(event.eventData, dataAction, key, event.eventHelperData);
      });
      setExtraEventJsonData(event.eventData);
      var shouldTrigger = true;
      if (!!event.dataActions['postTriggerCondition'] && Object.keys(event.dataActions['postTriggerCondition']).length) {
        _.each(event.dataActions['postTriggerCondition'], function (postTriggerCondition) {
          if (!shouldTrigger) {
            return;
          }
          shouldTrigger = checkPostTriggerCondition(postTriggerCondition, event.eventData);
        });
      }
      if (!!event.dataActions['checkEventRegistry']) {
        shouldTrigger = !checkEventRegistry(forge_sha256(JSON.stringify(event.eventData)));
      }
      if (shouldTrigger) {
        sendEvent(event.eventType, event.eventData, true);
        if (!!event.dataActions.resetSetEventJsonData) {
          $.data(document.body, 'setEventJsonData', {});
        }
      }
    }
    _.each(event.triggerActions, function (triggerAction) {
      var eventData = {};
      eventData.eventType = event.eventType;
      eventData.eventData = event.eventData;
      eventData.eventHelperData = event.eventHelperData;
      eventData.dataActions = event.dataActions || {};
      eventData.trigger = triggerAction;
      switch (triggerAction.event) {
        case 'live':
          if (!triggerAction.notOff || triggerAction.notOff !== true) {
            $(document).off(triggerAction.action, triggerAction.element);
          }
          $(document).on(triggerAction.action, triggerAction.element, eventData, function (onEvent) {
            triggerActionCallback(onEvent, this);
          });
          break;
        case 'one':
          if (!triggerAction.notOff || triggerAction.notOff !== true) {
            $(triggerAction.element).off(triggerAction.action);
          }
          $(triggerAction.element).one(triggerAction.action, eventData, function (onEvent) {
            triggerActionCallback(onEvent, this);
          });
          break;
        default:
          if (!triggerAction.notOff || triggerAction.notOff !== true) {
            $(triggerAction.element).off(triggerAction.action);
          }
          if (triggerAction.element === 'window') {
            triggerAction.element = window;
          }
          if (triggerAction.element === 'document') {
            triggerAction.element = document;
          }
          $(triggerAction.element).on(triggerAction.action, eventData, function (onEvent) {
            if (!triggerAction.eventWrapper) {
              triggerActionCallback(onEvent, this);
              return;
            }
            triggerActionCallback(onEvent, this, triggerAction.eventWrapper);
          });
          if (triggerAction.extra === "triggerOnLoad") {
            $(triggerAction.element).trigger(triggerAction.action);
          }
          break;
      }
    });
    _.each(event.mutationActions, async function (dataMutation) {
      DataLayerMutation.createObserver(dataMutation);
    });
    _.each(event.extraTriggerActions, async function (extraTriggerAction) {
      DataLayerExtraTriggers.addTrigger(extraTriggerAction);
    });
  }
  function triggerActionCallback(onEvent, self, wrapperElement) {
    window.historyState = $.extend(true, {}, history.state);
    var eventJson = onEvent.data.eventData;
    var eventHelperData = onEvent.data.eventHelperData;
    var thisEvent = self;
    if (!!onEvent.data.trigger.previousAction) {
      var previousActionKey = !!onEvent.data.trigger.previousActionKey ? onEvent.data.trigger.previousActionKey : 'dl-last-event';
      if (!$.data(document.body, previousActionKey)) {
        return;
      }
      if (onEvent.data.trigger.previousAction !== $.data(document.body, previousActionKey)) {
        return;
      }
    }
    if (!!onEvent.data.trigger.triggerCondition) {
      if (!checkTriggerCondition(onEvent.data.trigger.triggerCondition, eventJson.event_name)) {
        return;
      }
    }
    _.each(onEvent.data.trigger.dataActions, async function (dataAction) {
      processTriggerDataAction(eventJson, dataAction, eventHelperData, thisEvent);
    });
    _.each(onEvent.data.dataActions, async function (dataAction, key) {
      eventJson = processEventDataAction(eventJson, dataAction, key, eventHelperData, thisEvent, wrapperElement);
    });
    setExtraEventJsonData(eventJson);
    var shouldTrigger = true;
    if (!!onEvent.data.dataActions['postTriggerCondition'] && Object.keys(onEvent.data.dataActions['postTriggerCondition']).length) {
      _.each(onEvent.data.dataActions['postTriggerCondition'], function (postTriggerCondition) {
        if (!shouldTrigger) {
          return;
        }
        shouldTrigger = checkPostTriggerCondition(postTriggerCondition, eventJson);
      });
    }
    if (shouldTrigger && !!onEvent.data.dataActions['checkEventRegistry']) {
      shouldTrigger = !checkEventRegistry(forge_sha256(JSON.stringify(eventJson)));
    }
    if (shouldTrigger) {
      sendEvent(onEvent.data.eventType, eventJson, onEvent.data.trigger.forceDispatch);
      if (!!onEvent.data.dataActions.resetSetEventJsonData) {
        $.data(document.body, 'setEventJsonData', {});
      }
    }
  }
  function incrementValue(data) {
    if (typeof data === 'number') {
      data++;
    } else {
      data = eval(data + '+1');
    }
    return data;
  }
  function getShopListNames(dataAction) {
    var elements = $(dataAction.element),
      shopListNames = {},
      header;
    if (!elements.length) {
      return shopListNames;
    }
    _.each(elements, function (element) {
      header = $(element).find(dataAction.header).text().toLowerCase();
      var activeFilters = $(element).find(dataAction.find),
        activeFilterLabels = [],
        currentFilterLabel;
      _.each(activeFilters, function (filter) {
        if ($(filter).find(dataAction.filter).length) {
          currentFilterLabel = $(filter).find(dataAction.filter).text();
        } else {
          currentFilterLabel = $(filter).find(dataAction.ifFilter).clone().children().remove().end().text();
        }
        activeFilterLabels.push(currentFilterLabel.trim().toLowerCase());
      });
      shopListNames[header] = activeFilterLabels;
    });
    return shopListNames;
  }
  function getOosColorsByCmsProductOption(productTitle, productOptions, dataAction) {
    var oosColors = [],
      nameParts,
      color;
    _.each(productOptions, function (productOption) {
      if (productOption.product_colour_out_of_stock === 'true') {
        productTitle = prepareProductTitle(productTitle, productOption[dataAction.map['product_name']]);
        nameParts = productOption[dataAction.map['product_name']].replace(productTitle, '').trim().split(' ');
        if (nameParts.length > 1) {
          nameParts.shift();
        }
        color = nameParts.join(' ');
        oosColors.push(color.toLowerCase());
      }
    });
    return oosColors;
  }
  function prepareProductTitle(productTitle, productName) {
    var titleParts = productTitle.split(' ');
    if (-1 === productName.indexOf(titleParts[0])) {
      titleParts.shift();
    }
    return titleParts.join(' ');
  }
  function getExistingElementText(dataAction) {
    var destination;
    _.each(dataAction.elements, function (element) {
      if (!destination && !!$(element) && $(element).length) {
        destination = $(element).text();
      }
    });
    if (dataAction.replace && !!destination && destination.length) {
      _.each(dataAction.replace, function (to, from) {
        destination = destination.replaceAll(from, to);
      });
    }
    return destination;
  }
  function evaluateMath(string) {
    string = string.replaceAll('++', '+').replaceAll('--', '-').replaceAll('/*', '/').replaceAll('*/', '*');
    return eval(string);
  }
  function filterObsoleteData(eventData) {
    var updatedData = $.extend(true, {}, eventData),
      regex = /^(cp.|dom.|tealium_|ut.|meta.|_c|auth_|aa_|captify_|fl_|fto_|is_captify_|is_mediaiq_|mediaiq_)/;
    _.each(updatedData, function (value, key) {
      if (regex.test(key)) {
        delete updatedData[key];
      }
    });
    return updatedData;
  }
  function prepareProductDataByHitsUpdated(dataAction) {
    var keysToRemove = dataAction.remove,
      hitUpdatedKeys,
      productData = {},
      newProductsOnly = !!$.data(document.body, 'nextEventNewProductsOnlyMode'),
      lastCollectionData = !!$.data(document.body, 'lastCollection') ? $.data(document.body, 'lastCollection') : {};
    if (!!window.hitsUpdated && Object.keys(window.hitsUpdated).length) {
      _.each(window.hitsUpdated, function (hitUpdated) {
        if (newProductsOnly && !!lastCollectionData && !!lastCollectionData['product_group_id'] && lastCollectionData['product_group_id'].indexOf(hitUpdated.product_group_id) !== -1) {
          return;
        }
        hitUpdatedKeys = Object.keys(hitUpdated);
        _.each(hitUpdatedKeys, function (key) {
          if (!!keysToRemove && -1 !== keysToRemove.indexOf(key)) {
            return;
          }
          switch (key) {
            case 'product_name':
              if (-1 !== hitUpdated[key].indexOf(hitUpdated['product_brand'])) {
                hitUpdated[key] = hitUpdated[key].replace(hitUpdated['product_brand'], '').trim();
              }
              break;
            case 'product_colour_out_of_stock':
              if (typeof hitUpdated[key] === 'string') {
                hitUpdated[key] = hitUpdated[key].toLowerCase();
              }
              break;
          }
          if (!productData[key]) {
            productData[key] = [];
          }
          productData[key].push(hitUpdated[key]);
        });
      });
    }
    if (newProductsOnly) {
      $.data(document.body, 'nextEventNewProductsOnlyMode', false);
    }
    if (Object.keys(productData).length) {
      $.data(document.body, 'lastCollection', mergeObjects(lastCollectionData, productData));
    }
    return productData;
  }
  function mergeObjects(object1, object2) {
    var keys = Object.keys(object1).length ? Object.keys(object1) : Object.keys(object2),
      result = {};
    _.each(keys, function (key) {
      if (!object1[key]) {
        object1[key] = [];
      }
      if (!object2[key]) {
        object2[key] = [];
      }
      result[key] = object1[key].concat(object2[key]);
    });
    return result;
  }
  function checkEventRegistry(eventHash) {
    var eventRegistry = !!$.data(document.body, 'eventRegistry') ? $.data(document.body, 'eventRegistry') : [],
      result = false;
    if (-1 !== (eventRegistry === null || eventRegistry === void 0 ? void 0 : eventRegistry.indexOf(eventHash))) {
      result = true;
    } else {
      eventRegistry.push(eventHash);
      $.data(document.body, 'eventRegistry', eventRegistry);
    }
    return result;
  }
  function prepareHelperDataByHitsUpdated(dataAction) {
    var arrayValues = !!dataAction.arrayValues;
    if (!arrayValues) {
      return !!window.hitsUpdated ? window.hitsUpdated : [];
    }
    var hitUpdatedKeys,
      helperData = [];
    if (!window.hitsUpdated) {
      return helperData;
    }
    _.each(window.hitsUpdated, function (hitUpdated, position) {
      hitUpdatedKeys = Object.keys(hitUpdated);
      _.each(hitUpdatedKeys, function (key) {
        if (!Array.isArray(hitUpdated[key])) {
          hitUpdated[key] = [hitUpdated[key]];
        }
      });
      if (!helperData[position]) {
        helperData[position] = [];
      }
      helperData[position] = hitUpdated;
    });
    return helperData;
  }
  function checkPostTriggerCondition(postTriggerCondition, eventJson) {
    var shouldTrigger = true,
      value;
    switch (postTriggerCondition.type) {
      case 'eventJson':
        switch (postTriggerCondition.condition) {
          case 'positive':
            value = eventJson[postTriggerCondition.key];
            if (!value) {
              return false;
            }
            if (!!postTriggerCondition.extra) {
              value = eval(postTriggerCondition.extra + '(' + value + ')');
            }
            shouldTrigger = !!value && value > 0;
            break;
          case 'notArray':
            value = eventJson[postTriggerCondition.key];
            if (!value) {
              break;
            }
            if (!!postTriggerCondition.shift && Array.isArray(value)) {
              value = value[0];
            }
            return !Array.isArray(value);
          case 'notEmpty':
            return !!eventJson[postTriggerCondition.key];
          case 'notEmpty.conditional':
            if (eventJson[postTriggerCondition.key] === postTriggerCondition.value) {
              return !!eventJson[postTriggerCondition.jsonKey] !== '';
            }
            break;
        }
        break;
      case 'hitsUpdated':
        switch (postTriggerCondition.condition) {
          case 'positive':
            shouldTrigger = !!window.hitsUpdated && Object.keys(window.hitsUpdated).length;
            break;
        }
        break;
      case 'parseInt':
        var numberString = $(postTriggerCondition.element).text(),
          number;
        if (!!postTriggerCondition.replace && Object.keys(postTriggerCondition.replace).length) {
          _.each(postTriggerCondition.replace, function (to, from) {
            numberString = numberString.replaceAll(from, to);
          });
        }
        number = parseInt(numberString);
        switch (postTriggerCondition.condition) {
          case 'positive':
            shouldTrigger = number > 0;
            break;
        }
        break;
      case 'lastTriggeredEvent':
        if (!!$.data(document.body, 'dl-last-event') && !!(eventJson !== null && eventJson !== void 0 && eventJson.event_name)) {
          switch (postTriggerCondition.condition) {
            case 'neq':
              shouldTrigger = $.data(document.body, 'dl-last-event') !== postTriggerCondition.eventName;
              break;
          }
        }
        break;
      case 'css':
        var property = $(postTriggerCondition.element).css(postTriggerCondition.property);
        switch (postTriggerCondition.conditionType) {
          case 'eq':
            shouldTrigger = property === postTriggerCondition.value;
            break;
          case 'neq':
            shouldTrigger = property !== postTriggerCondition.value;
            break;
        }
        break;
      case 'document.body.data':
        var bodyDataValue = $.data(document.body, postTriggerCondition.key);
        switch (postTriggerCondition.conditionType) {
          case 'eq':
            shouldTrigger = bodyDataValue === postTriggerCondition.value;
            break;
        }
        if (shouldTrigger && postTriggerCondition.extra) {
          switch (postTriggerCondition.extra) {
            case 'toggle':
              $.data(document.body, postTriggerCondition.key, !bodyDataValue);
              break;
          }
        }
        break;
    }
    return shouldTrigger;
  }
  function preparePdpEventHelperData(dataAction, eventJson, eventHelperData) {
    var result;
    _.each(dataAction, function (condition, destination) {
      switch (destination) {
        case 'product_upfront_cost':
          {
            let productUpfrontCost = deal.puf;
            if (productUpfrontCost === 'all') {
              productUpfrontCost = deal.deviceFullPrice;
            }
            let productUpfrontCostFormatted = parseFloat(productUpfrontCost).toFixed(2);
            eventJson[destination] = [productUpfrontCostFormatted];
            break;
          }
        case 'product_monthly_cost':
          {
            let productMonthlyCostFormatted = parseFloat(deal.deviceMonthlyPrice).toFixed(2);
            eventJson[destination] = [productMonthlyCostFormatted];
            break;
          }
        case 'product_sku':
        case 'product_stock_status':
          var selectedSwatches = $(condition.element),
            valueA,
            valueB;
          switch (selectedSwatches.length) {
            case 2:
              valueA = $(selectedSwatches[0]).text().toLowerCase();
              valueB = $(selectedSwatches[1]).text().toLowerCase();
              if (!!eventHelperData['device'] && Object.keys(eventHelperData['device']).length && eventHelperData['device'][valueA] !== undefined && eventHelperData['device'][valueA][valueB] !== undefined && eventHelperData['device'][valueA][valueB][destination] !== undefined) {
                result = eventHelperData['device'][valueA][valueB][destination];
                eventJson[destination] = !!condition.array ? [result] : result;
              }
              break;
            case 1:
              valueA = $(selectedSwatches).text().toLowerCase();
              if (!!eventHelperData['device'] && Object.keys(eventHelperData['device']).length && eventHelperData['device'][valueA][destination] !== undefined && eventHelperData['device'][valueA][destination] !== undefined) {
                result = eventHelperData['device'][valueA][destination];
                eventJson[destination] = !!condition.array ? [result] : result;
              }
              break;
            case 0:
              return;
          }
          break;
        case 'product_tariff_id':
          let value = $(condition.element).find(condition.find).parent().find(condition.selector);
          if (!!value) {
            if (!!eventHelperData['tariff'] && Object.keys(eventHelperData['tariff']).length) {
              value = value.text();
              if (condition.replace) {
                value = replaceString(value, condition.replace).trim();
              }
              result = eventHelperData['tariff'][value.toLowerCase()];
              eventJson[destination] = !!condition.array ? [result] : result;
            }
          }
          break;
        case 'product_payment_method':
          let data = $(condition.element);
          if (!!data) {
            data = data.attr('data-name');
            eventJson[destination] = [data];
          }
          break;
      }
    });
    return eventJson;
  }
  function replaceString(val, dataActionReplace) {
    _.each(dataActionReplace, function (to, from) {
      if (typeof val === 'string') {
        val = val.replaceAll(from, to);
      }
    });
    return val;
  }
  function checkTriggerCondition(triggerCondition, eventName) {
    switch (triggerCondition.type) {
      case 'isInDOM':
        if (0 === $(triggerCondition.element).length) {
          return false;
        }
        break;
      case 'isInViewport':
        if (!isInViewport(triggerCondition.element)) {
          return false;
        }
        break;
      case 'isInViewportOnce':
        if (!isInViewport(triggerCondition.element) || triggerCondition.triggered) {
          return false;
        }
        triggerCondition.triggered = true;
        break;
      case 'css':
        return validateCondition(triggerCondition, $(triggerCondition.element).css(triggerCondition.css));
      case 'val':
        return validateCondition(triggerCondition, $(triggerCondition.element).val());
      case 'avoidNextDlEventMode':
        if (!!$.data(document.body, 'avoidNextDlEventMode') && ($.data(document.body, 'avoidNextDlEventMode') === eventName || $.data(document.body, 'avoidNextDlEventMode') === undefined)) {
          $.data(document.body, 'avoidNextDlEventMode', '');
          return false;
        }
        break;
    }
    return true;
  }
  function validateCondition(condition, value) {
    switch (condition.conditionType) {
      case 'neq':
        return value !== condition.value;
      default:
        return true;
    }
  }
  function processEventDataAction(eventJson, dataAction, key, eventHelperData) {
    let thisEvent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    let wrapperElement = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    if (dataAction.find) {
      var data = '';
      if (dataAction.extra === 'concat') {
        if (dataAction.prop) {
          var dataArray = [],
            name = '';
          $(dataAction.element).find(dataAction.find).each(function () {
            if (true === $(this).prop(dataAction.prop)) {
              name = $(this).prop('name');
              if (dataAction.remove && dataAction.remove.length) {
                _.each(dataAction.remove, function (searchValue) {
                  name = name.replace(searchValue, '');
                });
              }
              dataArray.push(name);
            }
          });
          if (dataArray.length) {
            data = dataArray.join('|');
          } else {
            data = 'none';
          }
        }
      } else {
        data = $(dataAction.element).find(dataAction.find).val();
      }
      if (key === 'plp.filter.shop_list_name') {
        var shopListNames = getShopListNames(dataAction),
          listNameParts = [];
        _.each(shopListNames, function (labels, header) {
          var labelsConcated = labels.join('_');
          listNameParts.push(header + '-' + labelsConcated);
        });
        if (listNameParts.length) {
          data = listNameParts.join('|');
        } else {
          data = dataAction.default;
        }
        eventJson[dataAction.destination] = data;
      }
      if (dataAction.extra === 'sha256') {
        data = forge_sha256(data);
      }
      if (dataAction.extra === 'lowercase') {
        data = data.toLowerCase();
      }
      if (!data) {
        data = '';
      }
      if (dataAction.destination) {
        eventJson[dataAction.destination] = data.toString();
      }
    }
    if (dataAction.merge) {
      if (dataAction.merge === 'setEventHelperData') {
        eventHelperData = prepareHelperDataByHitsUpdated(dataAction);
      }
      var index = $(thisEvent).closest('li').index() + 1;
      if (index > 0) {
        var dataObject = eventHelperData[index];
        if (dataObject) {
          $.extend(eventJson, dataObject);
        }
      }
    }
    if (dataAction.action === 'merge_helper_data') {
      if (dataAction.function === 'html') {
        var index = $(dataAction.element).html().toLowerCase();
      } else {
        var index = $(dataAction.element).val().toLowerCase();
      }
      var dataObject = eventHelperData[index];
      if (dataObject) {
        $.extend(eventJson, dataObject);
      }
    }
    if (key === 'add_pagetype_data') {
      _.each(dataAction.fields, function (index) {
        if (typeof utag_data[index] !== 'undefined') {
          eventJson[index] = utag_data[index];
        }
      });
    }
    if (key === 'customerdata') {
      var sectionJson = customerData.get(dataAction.section_name);
      if (sectionJson()) {
        eventJson = $.extend(true, sectionJson(), eventJson);
        delete eventJson.data_id;
      }
    }
    if (key === 'algolia_search') {
      if (dataAction.contextElements) {
        var clickContextIndex, clickContext, elementPosition;
        _.each(dataAction.contextElements, function (element) {
          clickContextIndex = $(thisEvent).closest(element);
          clickContext = $(element).index(clickContextIndex);
          if (clickContext !== -1) {
            elementPosition = clickContext;
          }
        });
      }
      _.each(dataAction.fields, function (index) {
        if (elementPosition) {
          eventJson[index] = [window.searchResult[index][elementPosition]];
        } else {
          eventJson[index] = window.searchResult[index];
        }
      });
      var typeData = [];
      window.searchResult['product_group_id'].forEach(function (item) {
        if (eventHelperData[item.toLowerCase()]) {
          typeData.push(eventHelperData[item.toLowerCase()]['product_type']);
        }
      });
      eventJson['product_type'] = typeData;
      var helpCount = $('.algolia-instant-results-wrapper .tab.help .count').html();
      if (helpCount && helpCount.length) {
        helpCount = helpCount.replace(/[()]/g, '');
      }
      var guideCount = $('.algolia-instant-results-wrapper .tab.guides .count').html();
      if (guideCount && guideCount.length) {
        guideCount = guideCount.replace(/[()]/g, '');
      }
      var shopCount = $('.algolia-instant-results-wrapper .tab.products .count').html();
      if (shopCount && shopCount.length) {
        shopCount = shopCount.replace(/[()]/g, '');
      }
      eventJson['search_all_result_count'] = "s=" + shopCount + "|h=" + helpCount + "|g=" + guideCount;
      eventJson['search_selected_result_count'] = shopCount;
      eventJson['search_result_sort'] = $('#algolia-sorts select').find(":selected").text().toLowerCase();
    }
    if (key === 'utag' && dataAction.merge) {
      var eventJsonClone = $.extend(true, {}, eventJson);
      $.extend(eventJson, utag_data);
      $.extend(eventJson, eventJsonClone);
      if (dataAction.remove) {
        _.each(dataAction.remove, function (key) {
          delete eventJson[key];
        });
      }
      eventJson = filterObsoleteData(eventJson);
    }
    if (key === 'conditionalSearchResults') {
      var conditionalField = dataAction.conditionalField,
        activeTab = eventJson[conditionalField],
        activeTabHtml = dataAction.tabToHtml[activeTab],
        tabProperties = dataAction[activeTabHtml],
        preparingData = [],
        preparedData = {},
        position = 1,
        conditionalElement,
        results;
      if (!!dataAction.element) {
        conditionalElement = dataAction.element.replace('%ACTIVE_TAB%', activeTabHtml);
      } else if (!!dataAction.conditionalElement) {
        conditionalElement = dataAction.conditionalElement[activeTabHtml];
      }
      if (conditionalElement && tabProperties) {
        results = $(conditionalElement);
        _.each(tabProperties, function (properties, dest) {
          _.each(results, function (element) {
            switch (properties.type) {
              case 'text':
                preparingData.push($(element).find(properties.element).text().trim().toLowerCase());
                break;
              case 'text.noChilds':
                preparingData.push($(element).find(properties.element).clone().children().remove().end().text().trim().toLowerCase());
                break;
              case 'href':
                preparingData.push($(element).find(properties.element).attr('href').toLowerCase());
                break;
              case 'count':
                preparingData.push(position.toString());
                position++;
                break;
            }
          });
          preparedData[dest] = preparingData;
          preparingData = [];
        });
        _.each(preparedData, function (datum, key) {
          eventJson[key] = datum;
        });
      }
    }
    if (key === 'conditionalRemove') {
      var eventJsonClone = $.extend(true, {}, eventJson),
        tab;
      if (!window.eventJsonClone) {
        window.eventJsonClone = {};
      }
      window.eventJsonClone = $.extend(window.eventJsonClone, eventJsonClone);
      eventJson = window.eventJsonClone;
      _.each(dataAction, function (propsToRemove, propKey) {
        tab = !!eventJson[propKey] ? eventJson[propKey] : 'help';
        if (propsToRemove[tab]) {
          _.each(propsToRemove[tab], function (val) {
            delete eventJson[val];
          });
        }
      });
    }
    if (key === 'carousel-product-tile') {
      var $carouselTitle = $(wrapperElement),
        products = $carouselTitle.parent().find(dataAction.find),
        jsonProductData,
        productDatas,
        carouselId,
        productData,
        productOptions,
        productTitle,
        brandElements,
        brand,
        position = 1,
        prices,
        isInStock;
      eventJson['shop_list_name'] = $carouselTitle.text().toString().toLowerCase();
      _.each(products, function (productElement) {
        var _productData;
        jsonProductData = $(productElement).attr(dataAction.attr);
        try {
          productDatas = JSON.parse(jsonProductData);
        } catch (e) {
          return;
        }
        carouselId = Object.keys(productDatas).shift();
        productData = productDatas[carouselId];
        productOptions = (_productData = productData) === null || _productData === void 0 ? void 0 : _productData.product_options;
        productTitle = productData[dataAction.map['product_name']];
        if (!eventJson['product_group_id']) {
          eventJson['product_group_id'] = [];
          eventJson['product_type'] = [];
          eventJson['product_brand'] = [];
          eventJson['product_name'] = [];
          eventJson['product_list_position'] = [];
          eventJson['product_stock_status'] = [];
          eventJson['product_colour_out_of_stock'] = [];
          eventJson['product_has_offer'] = [];
        }
        eventJson['product_group_id'].push(productData[dataAction.map['product_group_id']].toLowerCase());
        var productType = getProductType(productOptions);
        eventJson['product_type'].push(productType.toLowerCase());
        brandElements = $(productElement).find(dataAction['brands']);
        brand = brandElements.length ? $(brandElements[0]).text() : '';
        eventJson['product_brand'].push(brand.toLowerCase());
        eventJson['product_name'].push(productTitle.toLowerCase().replace(brand.toLowerCase(), '').trim());
        eventJson['product_list_position'].push(position.toString());
        position++;
        eventJson['product_stock_status'].push(productData['product_stock_status'].toLowerCase());
        var oosColors = getOosColorsByCmsProductOption(productTitle, productOptions, dataAction);
        eventJson['product_colour_out_of_stock'].push(oosColors.join('|'));
        eventJson['product_has_offer'].push(productData.product_has_offer);
      });
    }
    if (key === 'promotion-banner-impression') {
      var promoBannerWrapper = $(wrapperElement),
        jsonBannerData,
        bannerDatas,
        promoId,
        bannerData,
        imageOptions,
        bannerPosition;
      var liIndex = $(promoBannerWrapper[0]);
      bannerPosition = $(dataAction.element).index(liIndex);
      _.each(promoBannerWrapper, function (promoBanner) {
        jsonBannerData = $(promoBanner).attr(dataAction.attr);
        if (!jsonBannerData) {
          return;
        }
        try {
          bannerDatas = JSON.parse(jsonBannerData);
        } catch (e) {
          return;
        }
        promoId = Object.keys(bannerDatas).shift();
        bannerData = bannerDatas[promoId];
        imageOptions = bannerData.image;
        if (!eventJson['carousel_id']) {
          eventJson['carousel_id'] = [];
          eventJson['carousel_image_id'] = [];
          eventJson['carousel_image_alt_text'] = [];
          eventJson['carousel_image_position'] = [];
          eventJson['carousel_image_link'] = [];
        }
        eventJson['carousel_id'] = $(promoBannerWrapper).closest(dataAction.carouselIdSelector).attr('id');
        eventJson['carousel_image_id'] = $(promoBanner).attr('id');
        eventJson['carousel_image_alt_text'] = $(promoBanner).attr('data-title');
        bannerPosition++;
        eventJson['carousel_image_position'] = bannerPosition.toString();
        eventJson['carousel_image_link'] = !!bannerData['xdm:linkURL'] ? bannerData['xdm:linkURL'] : '';
      });
    }
    if (key === 'addEventCollectionData') {
      var productData = prepareProductDataByHitsUpdated(dataAction);
      if (Object.keys(productData).length) {
        $.extend(eventJson, productData);
      }
    }
    if (key === 'saveRelatedProductsData') {
      $.data(document.body, 'related-collection-data', extractProductProperties(eventJson));
    }
    if (key === 'existing-element') {
      eventJson[dataAction.destination] = getExistingElementText(dataAction);
    }
    if (key === 'pdpEventHelperData') {
      eventJson = preparePdpEventHelperData(dataAction, eventJson, eventHelperData);
    }
    if (key === 'location.change') {
      window.previousLocation = location.href.toString();
    }
    if (key === 'popstate.hash.trigger') {
      $(window).on('popstate', function (event) {
        var hash = window.location.hash.replace('#', ''),
          eventName = dataAction.actionPrefix + hash;
        if ($(dataAction.element).data('dl-last-event-triggered') !== eventName && $.data(document.body, 'dl-last-event') !== eventName) {
          $(dataAction.element).trigger(eventName);
          $(dataAction.element).data('dl-last-event-triggered', eventName);
          $.data(document.body, 'dl-last-event', eventName);
          if (!!dataAction.setEventNameExtraKey) {
            $.data(document.body, dataAction.setEventNameExtraKey, eventName);
          }
        }
      });
    }
    if (key === 'dataActions') {
      _.each(dataAction, function (triggerDataAction) {
        processTriggerDataAction(eventJson, triggerDataAction, eventHelperData, thisEvent);
      });
    }
    return eventJson;
  }
  function setExtraEventJsonData(eventJson) {
    var extraActions = $.data(document.body, 'setEventJsonData');
    if (!!extraActions) {
      _.each(extraActions, function (value, destination) {
        eventJson[destination] = value;
      });
    }
  }
  function extractProductProperties(eventJson) {
    var propertyNames = Object.getOwnPropertyNames(eventJson),
      propertyPrefix = 'product_',
      productProperties = {};
    _.each(propertyNames, function (propertyName) {
      if (propertyName.indexOf(propertyPrefix) === 0) {
        productProperties[propertyName] = eventJson[propertyName];
      }
    });
    return productProperties;
  }
  function processTriggerDataAction(eventJson, dataAction, eventHelperData, thisEvent) {
    var _$$parent, _$$parent2;
    var data = '';
    switch (dataAction.type) {
      case 'first':
        data = $(thisEvent).find(dataAction.find).first().text();
        break;
      case 'first.conditionalDestinations':
        var conditionalElementText = $(thisEvent).parent().find(dataAction.conditionalElement).text();
        data = $(thisEvent).find(dataAction.find).first().text();
        _.each(dataAction.conditionalDestinations, function (value, key) {
          if (conditionalElementText.toLowerCase() === key && data.length) {
            dataAction.destination = value;
          }
        });
        break;
      case 'first.noChilds':
        data = $(thisEvent).find(dataAction.find).clone().children().remove().end().text();
        break;
      case 'find':
        data = $(thisEvent).find(dataAction.find).contents().text().trim().toLowerCase();
        break;
      case 'find.noChilds':
        data = $(thisEvent).find(dataAction.find).clone().children().remove().end().text().trim().toLowerCase();
        break;
      case 'find.noHtml':
        var dataValue = $(thisEvent).parent().find(dataAction.find).text().length;
        data = dataValue ? 1 : 0;
        break;
      case 'find.noHtml.element':
        data = $(dataAction.element).parent().find(dataAction.className).length ? '1' : '0';
        break;
      case 'find.active':
        var dataValue = $(dataAction.element).clone().hasClass('active');
        data = dataValue ? 1 : 0;
        break;
      case 'parent.find':
        data = $(thisEvent).parent().find(dataAction.find).text();
        break;
      case 'parent.find.attr':
        data = $(thisEvent).parent().find(dataAction.find).attr(dataAction.attr);
        break;
      case 'parent.closest.attr':
        data = $(thisEvent).closest(dataAction.closest).attr(dataAction.attr);
        break;
      case 'parent.closest.text':
        data = $(thisEvent).closest(dataAction.element).find(dataAction.find).text().trim();
        break;
      case 'parent.closest.text.noChilds':
        data = $(thisEvent).closest(dataAction.element).find(dataAction.find).clone().children().remove().end().text().trim();
        break;
      case 'parent.closest.text.eventHelperData':
        var eventHelperKey = $(thisEvent).closest(dataAction.element).find(dataAction.find).text().trim().toLowerCase();
        if (eventHelperData[eventHelperKey] && eventHelperData[eventHelperKey][dataAction.destination]) {
          data = eventHelperData[eventHelperKey][dataAction.destination];
        }
        break;
      case 'find.sibling-span':
        data = $(thisEvent).find(dataAction.find).siblings('span').text();
        break;
      case 'val':
        data = $(dataAction.element).val();
        break;
      case 'attr':
        var $node;
        if (!!dataAction.thisEvent) {
          $node = $(thisEvent).find(dataAction.element);
        } else {
          $node = $(dataAction.element);
        }
        data = $node ? $node.attr(dataAction.attr) : '';
        break;
      case 'text':
        if (!!dataAction.thisEvent) {
          data = $(thisEvent).contents().text().trim().toLowerCase();
        } else {
          data = $(dataAction.element).contents().text().trim().toLowerCase();
        }
        break;
      case 'text.noChilds':
        data = $(dataAction.element).clone().children().remove().end().contents().text().toLowerCase();
        break;
      case 'text.noChilds.thisEvent':
        if (dataAction.element) {
          data = $(thisEvent).find(dataAction.element).clone().children().remove().end().text().toLowerCase();
        } else {
          data = $(thisEvent).clone().children().remove().end().text().toLowerCase();
        }
        break;
      case 'text.noChilds.concat':
        var parts = [],
          elements = $(dataAction.element),
          tabName,
          counter;
        _.each(elements, function (element) {
          tabName = $(element).clone().children().remove().end().text().toLowerCase();
          counter = $(element).find(dataAction.find).clone().children().remove().end().text().toLowerCase();
          parts.push(tabName + '=' + counter);
        });
        if (parts.length) {
          data = parts.join('|');
        } else {
          data = '';
        }
        break;
      case 'val-starts-with':
        data = $(dataAction.element).val();
        if (data !== '') {
          data = /^\d/.test(data) ? dataAction.digits : dataAction.letters;
        }
        break;
      case 'fixed':
        data = dataAction.data;
        break;
      case 'count':
        data = $(dataAction.element).length;
        break;
      case 'visible':
        var ifVisible = dataAction.ifVisible || '',
          ifHidden = dataAction.ifHidden || '';
        if (dataAction.thisEvent) {
          if (!!dataAction.parent) {
            data = $(thisEvent).parent().find(dataAction.element).is(':visible') ? ifVisible : ifHidden;
          } else {
            data = $(thisEvent).find(dataAction.element).is(':visible') ? ifVisible : ifHidden;
          }
        } else {
          data = $(dataAction.element).is(':visible') ? ifVisible : ifHidden;
        }
        break;
      case 'filled-visible':
        var ifVisible = dataAction.ifVisible || '',
          ifHidden = dataAction.ifHidden || '',
          $filledElement = $(dataAction.filledElement),
          filledElementLength = $filledElement && $filledElement.val() ? $filledElement.val().length : 0;
        data = dataAction.default;
        if (filledElementLength) {
          data = $(dataAction.element).is(':visible') ? ifVisible : ifHidden;
        }
        break;
      case 'existing-element':
        _.each(dataAction.elements, function (element) {
          if (!data && $(element).length) {
            data = $(element).text();
          }
        });
        break;
      case 'existing.conditional':
        data = $(dataAction.element).length > 0 ? dataAction.exist : dataAction.notExist;
        break;
      case 'dynamic':
        var elementValue = $(dataAction.element).val();
        data = dataAction.default;
        _.each(dataAction.data, function (value, key) {
          if (elementValue === key) {
            data = value;
          }
        });
        break;
      case 'hitsUpdated':
        switch (dataAction.condition) {
          case 'positive':
            data = !!window.hitsUpdated && Object.keys(window.hitsUpdated).length ? dataAction.pass : dataAction.fail;
            break;
        }
        break;
      case 'multiply':
        var checkResult, index;
        _.each(dataAction.check, function (value, eventJsonKey) {
          checkResult = eventJson[eventJsonKey][0] === value ? dataAction.checkPassed : dataAction.checkFailed;
          index = dataAction.eventJsonElements.indexOf(dataAction.checkFailed);
          if (index !== -1) {
            dataAction.eventJsonElements.splice(index, 1);
          }
          if (!dataAction.eventJsonElements.includes(checkResult)) {
            dataAction.eventJsonElements.push(checkResult);
          }
        });
        var total = dataAction.multiplier === '*' || dataAction.multiplier === '/' ? 1 : 0;
        _.each(dataAction.eventJsonElements, function (element) {
          total += dataAction.multiplier + eventJson[element][0];
        });
        data = evaluateMath(total);
        break;
      case 'index':
        var liIndex = $(thisEvent).closest(dataAction.element);
        data = $(!!dataAction.parentElement ? dataAction.parentElement : dataAction.element).index(liIndex);
        break;
      case 'index.addEventProductData':
        var liElement = $(thisEvent).closest(dataAction.element),
          liIndex = $(!!dataAction.parentElement ? dataAction.parentElement : dataAction.element).index(liElement) + 1,
          productData;
        if (!!window.hitsUpdated && !!window.hitsUpdated[liIndex]) {
          productData = window.hitsUpdated[liIndex];
          _.each(productData, function (value, key) {
            if (!Array.isArray(value)) {
              value = [value];
            }
            eventJson[key] = value;
          });
        }
        return;
      case 'index.addRelatedProductData':
        var element = $(thisEvent).closest(dataAction.element),
          index = $(dataAction.element).index(element),
          productProperties = !!$.data(document.body, 'related-collection-data') ? $.data(document.body, 'related-collection-data') : {},
          productData = {};
        if (Object.keys(productProperties).length) {
          _.each(productProperties, function (data, propertyName) {
            productData[propertyName] = [data[index]];
          });
          $.extend(eventJson, productData);
        }
        break;
      case 'location.search':
        var parts = location.search ? location.search.replaceAll('?', '').split('&') : [],
          key = dataAction.key,
          pieces;
        _.each(parts, function (part) {
          if (data) {
            return;
          }
          pieces = part.split('=');
          if (pieces.length > 1 && 0 === pieces.indexOf(key)) {
            data = pieces[1];
          }
        });
        if (!data) {
          data = !!dataAction.default ? dataAction.default : '';
        }
        break;
      case 'parent.attr':
        data = (_$$parent = $(thisEvent).parent()) === null || _$$parent === void 0 ? void 0 : _$$parent.attr(dataAction.attr);
        break;
      case 'parent.attr.json':
        var jsonString = (_$$parent2 = $(thisEvent).parent()) === null || _$$parent2 === void 0 || (_$$parent2 = _$$parent2.attr(dataAction.attr)) === null || _$$parent2 === void 0 ? void 0 : _$$parent2.trim();
        try {
          var jsonData = JSON.parse(jsonString);
        } catch (e) {
          return;
        }
        var objectId = Object.keys(jsonData).shift(),
          datum;
        if (dataAction.jsonAttr === 'objectId') {
          datum = objectId;
        } else {
          datum = !!jsonData[objectId] && !!jsonData[objectId][dataAction.jsonAttr] ? jsonData[objectId][dataAction.jsonAttr] : '';
          if (!!dataAction.attrChild && datum[dataAction.attrChild]) {
            datum = datum[dataAction.attrChild];
          }
        }
        data = !!datum ? datum.toString().toLowerCase() : '';
        break;
      case 'parent.closest.attr.json':
        var jsonString = $(thisEvent).closest(dataAction.element).attr(dataAction.attr).trim();
        try {
          var jsonData = JSON.parse(jsonString);
        } catch (e) {
          return;
        }
        var objectId = Object.keys(jsonData).shift();
        if (dataAction.jsonAttr === 'product_type' && !!jsonData[objectId]['product_options']) {
          var productType = getProductType(jsonData[objectId]['product_options']);
          data = productType.toLowerCase();
        } else {
          data = !!jsonData[objectId][dataAction.jsonAttr] ? jsonData[objectId][dataAction.jsonAttr] : '';
        }
        break;
      case 'parent.closest.attr.json.oosColors':
        var jsonString = $(thisEvent).closest(dataAction.element).attr(dataAction.attr).trim();
        try {
          var jsonData = JSON.parse(jsonString);
        } catch (e) {
          return;
        }
        var objectId = Object.keys(jsonData).shift(),
          productOptions = jsonData[objectId][dataAction.jsonAttr],
          productTitle = jsonData[objectId][dataAction.map['product_name']],
          oosColors = getOosColorsByCmsProductOption(productTitle, productOptions, dataAction);
        data = oosColors.join('|');
        break;
      case 'plp.filter.shop_list_name':
        var shopListNames = getShopListNames(dataAction),
          listNameParts = [];
        _.each(shopListNames, function (labels, header) {
          var labelsConcated = labels.join('_');
          listNameParts.push(header + '-' + labelsConcated);
        });
        if (listNameParts.length) {
          data = listNameParts.join('|');
        } else {
          data = dataAction.default;
        }
        $.data(document.body, 'shop_list_name', data);
        break;
      case 'plp.filter.shop_facet_selection':
        var shopListNames = getShopListNames(dataAction),
          historyFilters = window.historyState,
          historyNameParts = {},
          shopFacetSelectionArray = {},
          shopFacetSelectionArrayStringified = {},
          shopFacetSelection = '';
        delete historyFilters.q;
        delete historyFilters.sortBy;
        delete historyFilters.page;
        delete historyFilters['price.GBP.default'];
        _.each(historyFilters, function (filterValues, filterCode) {
          if (filterValues) {
            var filterValueArray = filterValues.split('~'),
              filterValueArrayLowercase = [];
            _.each(filterValueArray, function (value) {
              filterValueArrayLowercase.push(value.toLowerCase());
            });
            historyNameParts[filterCode] = filterValueArrayLowercase;
          }
        });
        _.each(shopListNames, function (filterValues, attributeLabel) {
          var attributeCode = dataAction.map[attributeLabel];
          if (attributeCode) {
            _.each(filterValues, function (value) {
              if (!historyNameParts[attributeCode] || historyNameParts[attributeCode].indexOf(value) === -1) {
                if (!shopFacetSelectionArray[attributeLabel]) {
                  shopFacetSelectionArray[attributeLabel] = [];
                }
                shopFacetSelectionArray[attributeLabel].push(value);
              }
            });
          }
        });
        _.each(shopFacetSelectionArray, function (selectedValue, selectedLabel) {
          var concatedValues = Array.isArray(selectedValue) ? selectedValue.join('_') : selectedValue;
          shopFacetSelectionArrayStringified[selectedLabel] = concatedValues;
        });
        _.each(shopFacetSelectionArrayStringified, function (stringifiedValues, label) {
          shopFacetSelection += label + '|' + stringifiedValues;
        });
        data = shopFacetSelection;
        $.data(document.body, 'shop_facet_selection', data);
        break;
      case 'history':
        if (!!history[dataAction.key] && !!history[dataAction.key][dataAction.property]) {
          data = history[dataAction.key][dataAction.property].toString();
        } else {
          var _dataAction$default;
          data = dataAction === null || dataAction === void 0 || (_dataAction$default = dataAction.default) === null || _dataAction$default === void 0 ? void 0 : _dataAction$default.toString();
        }
        break;
      case 'document.body.data':
        data = $.data(document.body, dataAction.key);
        break;
      case 'document.body.data.conditional':
        var dataValue = $.data(document.body, dataAction.key);
        data = dataValue ? dataAction.ifSuccess : dataAction.ifFailed;
        break;
      case 'document.body.data.field':
        var documentData = $.data(document.body, dataAction.key);
        try {
          data = '';
          if (!!documentData[dataAction.field]) {
            data = documentData[dataAction.field];
          }
        } catch (exception) {
          data = '';
        }
        break;
      case 'document.body.data.jsonfield':
        var documentData = $.data(document.body, dataAction.key);
        try {
          data = '';
          if (!!documentData[dataAction.field]) {
            try {
              var jsonData = JSON.parse(documentData[dataAction.field]);
            } catch (e) {
              return;
            }
            if (!!jsonData[dataAction.json_field]) {
              data = jsonData[dataAction.json_field];
            }
          }
        } catch (exception) {
          data = !!documentData[dataAction.field] ? documentData[dataAction.field] : '';
        }
        break;
    }
    if (Array.isArray(data)) {
      eventJson[dataAction.destination] = data;
      return;
    }
    if (data || data === '' || data == '0') {
      if (dataAction.shift) {
        var words = data.split(' ');
        data = words.length ? words[0] : data;
      }
      if (dataAction.replace) {
        data = replaceString(data, dataAction.replace);
      }
      if (dataAction.extra === 'sha256') {
        data = forge_sha256(data);
      }
      if (dataAction.extra === 'lowercase') {
        data = data.toLowerCase();
      }
      if (dataAction.extra === 'increment') {
        data = incrementValue(data);
      }
      if (dataAction.extra === 'increment.checkBody') {
        if (!!dataAction.extraProperty && $.data(document.body, dataAction.extraProperty) === dataAction.value) {
          data = incrementValue(data);
        }
      }
      if (dataAction.extra === 'set-body-data') {
        $.data(document.body, dataAction.destination, data);
      }
    }
    if (dataAction.extra === 'evaluateMath') {
      var string = '';
      _.each(eventJson[dataAction.destination], function (value) {
        string = value + dataAction.multiplier + data;
        data = evaluateMath(string);
      });
    }
    if (dataAction.concat) {
      if (dataAction.concatCheck) {
        var indexOfConcatCheck = data.toString().indexOf(dataAction.concatCheck);
        if (indexOfConcatCheck === -1) {
          data = data + dataAction.concat;
        } else {
          var substring = data.toString().substring(indexOfConcatCheck);
          if (substring.length === 2) {
            data += '0';
          }
        }
      } else {
        data = data + dataAction.concat;
      }
    }
    if (dataAction.trim) {
      data = data.trim();
    }
    if (dataAction.postReplace) {
      data = replaceString(data, dataAction.postReplace);
    }
    if (!data && data != "0") {
      data = '';
    }
    if (typeof dataAction.destination !== 'undefined') {
      eventJson[dataAction.destination] = dataAction.array ? [data.toString()] : data.toString();
    }
  }
  function getProductType(productOptions) {
    var defaultType = 'handset',
      result;
    _.each(productOptions, function (option) {
      if (result) {
        return;
      }
      if (option !== null && option !== void 0 && option.product_type) {
        result = option.product_type;
      }
    });
    return !!result ? result : defaultType;
  }
  function startInit(config) {
    if (!config.initExecuted) {
      if (config.environment === 'dev') {
        console.log('Setup event: ' + config.method);
      }
      init(config);
      config.initExecuted = true;
    }
  }
  function sendEvent(eventType, eventJson, forceDispatch) {
    var eventDetail = $.extend(true, {}, eventJson),
      eventData,
      e = new CustomEvent(eventType, {
        detail: eventDetail
      });
    eventData = filterObsoleteData(eventDetail);
    if (window.lastTriggeredEvent !== JSON.stringify(eventData) || forceDispatch) {
      if (!eventData.event_name) {
        var eventId = forge_sha256(JSON.stringify(eventData));
        if (!forceDispatch && ($.data(document.body, 'dl-last-undefined-event-page-id') === eventData.page_id || $.data(document.body, 'dl-last-undefined-event') === eventId)) {
          return;
        }
        $.data(document.body, 'dl-last-undefined-event', eventId);
        $.data(document.body, 'dl-last-undefined-event-page-id', eventData.page_id);
      }
      document.dispatchEvent(e);
      if (window.eventLog) {
        console.log(e);
      }
      $.data(document.body, 'dl-last-event', eventJson.event_name);
      window.lastTriggeredEvent = JSON.stringify(eventData);
    }
  }
  function isInViewport(selector) {
    var element = document.querySelector(selector);
    if (!element) {
      return false;
    }
    var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      bottom = _element$getBoundingC.bottom;
    var vHeight = window.innerHeight || document.documentElement.clientHeight;
    return (top > 0 || bottom > 0) && top < vHeight;
  }
  return function (config) {
    var _config$eventLog;
    window.eventLog = (_config$eventLog = config.eventLog) !== null && _config$eventLog !== void 0 ? _config$eventLog : 0;
    if (config.environment === 'dev') {
      console.log('Init Datalayer-event: ' + config.method);
      console.log($.extend(true, {}, config));
    }
    if (config.init) {
      $(document).on(config.init, function () {
        startInit(config);
      });
      if (config.triggerActions.trigger) {
        $(window).load(function () {
          $(document).trigger(config.triggerActions.trigger.event);
        });
      }
    } else {
      startInit(config);
    }
  };
});

